import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

const requireAuthentication = Component => {
    class AuthenticatedComponent extends React.Component {
        componentWillMount() {
            this.checkAuth(this.props.isAuthenticated);
        }

        componentWillReceiveProps(nextProps) {
            this.checkAuth(nextProps.isAuthenticated);
        }

        checkAuth(isAuthenticated) {
            if (!isAuthenticated) {
                this.props.router.push(
                    `/login${this.props.location.query && this.props.location.query.newLogin ? '?newLogin=true' : ''}`
                );
            }
        }

        render() {
            return <div>{this.props.isAuthenticated === true ? <Component {...this.props} /> : null}</div>;
        }
    }

    AuthenticatedComponent.propTypes = {
        isAuthenticated: PropTypes.bool.isRequired,
        location: PropTypes.object.isRequired,
        router: PropTypes.object.isRequired
    };

    const mapStateToProps = state => ({
        isAuthenticated: state.oauth.isAuthenticated
    });

    return connect(mapStateToProps)(withRouter(AuthenticatedComponent));
};

export default requireAuthentication;



// WEBPACK FOOTER //
// ./src/components/helpers/requireAuthentication.js